import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GetCommunityTag, GetMyPrincipal } from 'nallian-shared-ui/lib/selectors';
import { PageContent, PageTitle } from 'nallian-shared-ui/lib/components';
import OverviewText from './OverviewText';
import MyAppsOverview from '../../apps/components/MyAppsOverview';

const Overview = () => {
  const { t } = useTranslation();

  const tag = useSelector(GetCommunityTag);
  const myPrincipal = useSelector(GetMyPrincipal);
  const language = myPrincipal.languageId || 'en';
  const name = get(myPrincipal, 'fullName', t('communityMember'));

  return (
    <>
      <PageTitle>{t('welcome')}</PageTitle>
      <PageContent>
        <OverviewText tag={tag} language={language} name={name} />
        <MyAppsOverview />
      </PageContent>
    </>
  );
};

export default Overview;
